export const CASHBACK_DEEPLINK_QUERY_PARAMS = {
  APP_ID: 'app_id',
};

export const CASHBACK_DEEPLINK_SESSION_KEYS = {
  RETURN_URL: 'cashback_deeplink.returnUrl',
};
